















































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbTooltip, mdbInput, mdbSelect, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbIcon, mdbAlert, mdbBadge, mdbCard, mdbCardUp, mdbCardBody, mdbCardFooter } from '@folky-tools/mdbvue';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Reference } from '@/models/references/reference';
import { ReferenceBasicData } from '@/models/references/reference-basic-data';
import { GenericResult } from '@/models/common/results/generic-result';
import { UserPermissionAction, UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { Category } from '@/models/references-classification/category';
import { Characteristic } from '@/models/references-classification/characteristic';
import { CharacteristicValue } from '@/models/references-classification/characteristic-value';
import { ReferenceImage, ReferenceImageSize } from '@/models/references/reference-image';
import { usersService, referencesService, referencesClassificationService, businessFrontPagesService, authorizationManagerService, notificationsService } from '@/services';
import Swal from 'sweetalert2';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbTooltip,
        mdbInput,
        mdbSelect,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbBtn,
        mdbIcon,
        mdbAlert,
        mdbBadge,
        mdbCard,
        mdbCardUp,
        mdbCardBody,
        mdbCardFooter,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        FileUpload: () => import('@/components/shared/FileUpload.vue'),
        Wysiwyg: () => import('@/components/shared/Wysiwyg.vue'),
        ReferenceBasicData: () => import('@/components/references/ReferenceBasicData.vue'),
        ReferenceImages: () => import('@/components/references/ReferenceImages.vue'),
        ReferenceCategories: () => import('@/components/references/ReferenceCategories.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class EditReferenceView extends Vue {
    private referenceBasicData: ReferenceBasicData = new ReferenceBasicData();
    private reference: Reference = new Reference();
    private referenceCopy: Reference = new Reference();
    private initialSelectedCategories: Category[] = [];
    private topLevelCategories: Category[] = [];
    private nonPhysicalDeliveryInstructionsHtml: string = '';
    private businessCharacteristics: Characteristic[] = [];
    private selectedImage: ReferenceImage = new ReferenceImage();

    private showNew: boolean = false;
    private showEditImage: boolean = false;
    private showEditTitleDescription: boolean = false;
    private showEditNonPhysicalDetails: boolean = false;
    private showEditCategoryCharacteristics: boolean = false;

    private savingNewReference: boolean = false;
    private publishingReference: boolean = false;
    private savingReferenceImage: boolean = false;
    private savingReferenceTitleDescription: boolean = false;
    private savingReferenceNonPhysicalDetails: boolean = false;
    private loadingReferenceCategoryCharacteristics: boolean = false;
    private savingReferenceCategoryCharacteristics: boolean = false;

    private pageContentLoaded: boolean = false;

    // #region GENERIC

    private async mounted(): Promise<void> {
        if (this.$route.params.id) {
            this.$root.$emit('change-active-page', 'views.references.editReferenceView.titleEditReference');
            this.reference = await referencesService.getReference(+this.$route.params.id);
            this.referenceCopy = this.reference.clone();

            this.onChangeNonPhysicalDeliveryInstructions();

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasVisited,
                    entity: UserActionEntityType.Products,
                    scope: UserActionScopeType.Edit,
                    entityId: this.reference.id
                })
            );
        } else {
            this.$root.$emit('change-active-page', 'views.references.editReferenceView.titleNewReference');
            this.showNew = true;

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasVisited,
                    entity: UserActionEntityType.Products,
                    scope: UserActionScopeType.New
                })
            );
        }

        setTimeout(() => this.switchPageContentToLoaded(), 10);
    }

    private switchPageContentToLoaded() {
        this.pageContentLoaded = true;
    }

    private async publish(): Promise<void> {
        this.publishingReference = true;

        if (this.reference.businessId && !(await businessFrontPagesService.isPublishedBusinessFrontPage(this.reference.businessId, true))) {
            notificationsService.showToastWarningNotification('views.references.editReferenceView.notifications.publishParentToPublishReference');
            this.publishingReference = false;
            return;
        }

        if (!this.reference.title) {
            notificationsService.showToastWarningNotification('views.references.editReferenceView.notifications.fillTitleToPublishReference');
            this.publishingReference = false;
            return;
        }

        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.references.editReferenceView.publish.modal.title').toString(),
            html: '<h3>' + this.reference.title + '</h3>' + this.$i18n.t('views.references.editReferenceView.publish.modal.textHtml').toString() + this.$i18n.t('common.warning.changesInWebTakeTime').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: true,
            focusCancel: false,
            confirmButtonText: this.$i18n.t('views.references.editReferenceView.publish.modal.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.references.editReferenceView.publish.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            try {
                if (await referencesService.publishReference(+this.$route.params.id)) {
                    this.reference.isPublishedInAConsumer = true;
                    this.referenceCopy = this.reference.clone();

                    notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.publishRefSuccess');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Products,
                            scope: UserActionScopeType.Publication,
                            entityId: this.reference.id
                        })
                    );

                    return;
                }
                notificationsService.showToastErrorNotification();
            } catch {
                notificationsService.showToastErrorNotification();
            } finally {
                this.publishingReference = false;
            }
        } else {
            this.publishingReference = false;
        }
    }

    // #endregion GENERIC

    // #region SAVE NEW REFERENCE

    private async saveNewReference(): Promise<number | undefined> {
        this.savingNewReference = true;

        if ((this.$refs.referenceBasicData as any).hasErrors()) {
            this.savingNewReference = false;
            return;
        }

        try {
            const newReferenceResult: GenericResult = await referencesService.newReference(this.referenceBasicData);
            if (newReferenceResult.result) {
                notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.saveRefSuccess');
                authorizationManagerService.addOrUpdatePermission(UserPermissionAction.Owner, UserEntityPermissionsType.References, newReferenceResult.id);

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.New,
                        entityId: newReferenceResult.id
                    })
                );

                this.showNew = false;

                return newReferenceResult.id;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingNewReference = false;
        }
    }

    private async saveNewReferenceAndloadList(): Promise<void> {
        const id = await this.saveNewReference();
        if (id) {
            this.$router.push({
                name: 'references'
            });
        }
    }

    private async saveNewReferenceAndGoToEditReference(): Promise<void> {
        const id = await this.saveNewReference();
        if (id) {
            this.$router.push({
                name: 'editProduct',
                params: { id: id!.toString() }
            });
        }
    }

    // #endregion SAVE NEW REFERENCE

    // #region EDIT IMAGES

    private addNewImage(): void {
        this.selectedImage = new ReferenceImage({ size: ReferenceImageSize.Original });
        this.showEditImage = true;
    }

    private async deleteImage(id: number): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.references.editReferenceView.removeImage.title').toString(),
            text: this.$i18n.t('views.references.editReferenceView.removeImage.text').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.references.editReferenceView.removeImage.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.references.editReferenceView.removeImage.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            if (await referencesService.deleteReferenceImage(this.reference.id, id)) {
                this.reference.images = this.reference.images.filter(image => image.id !== id);
                if (this.reference.images.length > 0) {
                    this.reference.images
                        .filter(image => image.id === this.reference.images[0].id)
                        .forEach(image => {
                            image.isPrincipal = true;
                        });
                }
                this.referenceCopy = this.reference.clone();

                notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.deleteImageSuccess');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Images,
                        entityId: this.reference.id
                    })
                );

                return;
            }

            notificationsService.showToastErrorNotification();
        }
    }

    private changeImage(id: number): void {
        this.selectedImage = this.reference.images.find(image => image.id === id && image.size === ReferenceImageSize.Original)!;
        this.showEditImage = true;
    }

    private async saveImage(): Promise<void> {
        this.savingReferenceImage = true;

        try {
            if (this.selectedImage.url) {
                if (this.selectedImage.id === 0 || this.selectedImage.url !== this.referenceCopy.images.find(image => image.id === this.selectedImage.id && image.size === this.selectedImage.size)!.url) {
                    const imageFile: File = (this.$refs.editImage as any).getFinalImageFile();

                    if (imageFile) {
                        const result = this.selectedImage.id > 0 ? await referencesService.updateReferenceImage(this.reference.id, this.selectedImage.id, imageFile) : await referencesService.newReferenceImage(this.reference.id, imageFile);

                        if (result) {
                            result.forEach(newImage => {
                                if (this.selectedImage.id > 0) {
                                    const image = this.reference.images.find(image => image.id === newImage.id && image.size === newImage.size)!;
                                    image.url = newImage.url;
                                } else {
                                    this.reference.images.push(newImage);
                                }
                            });
                            this.referenceCopy = this.reference.clone();
                            this.showEditImage = false;

                            notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.saveImageSuccess');

                            await usersService.logUserAction(
                                new UserActionLogInfo({
                                    type: UserActionType.HasChanged,
                                    entity: UserActionEntityType.Products,
                                    scope: UserActionScopeType.Images,
                                    entityId: this.reference.id
                                })
                            );

                            return;
                        }
                    }

                    notificationsService.showToastErrorNotification();
                    return;
                }
            }
            this.showEditImage = false;
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingReferenceImage = false;
        }
    }

    private closeEditImage(): void {
        this.reference = this.referenceCopy.clone();
        this.showEditImage = false;
    }

    // #endregion

    // #region EDIT TITLE & DESCRIPTION

    private editTitleDescription(): void {
        this.showEditTitleDescription = true;
    }

    private onUpdateDescription(htmlContent: string): void {
        this.reference.description = htmlContent;
    }

    private async saveTitleDescription(): Promise<void> {
        this.savingReferenceTitleDescription = true;

        if (this.reference.isPublishedInAConsumer && this.reference.title === '') {
            this.savingReferenceTitleDescription = false;
            return;
        }

        try {
            if (
                (this.reference.title === this.referenceCopy.title && this.reference.description === this.referenceCopy.description) ||
                (await referencesService.updateReferenceTitleDescription(this.reference.id, this.reference.title, this.reference.description))
            ) {
                this.referenceCopy = this.reference.clone();
                this.showEditTitleDescription = false;

                notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.updateIDSuccess');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.NameAndDescription,
                        entityId: this.reference.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingReferenceTitleDescription = false;
        }
    }

    private closeEditTitleDescription(): void {
        this.reference = this.referenceCopy.clone();
        this.showEditTitleDescription = false;
    }

    // #endregion EDIT TITLE & DESCRIPTION

    // #region NON PHYSICAL DETAILS

    private editNonPhysicalDetails(): void {
        this.showEditNonPhysicalDetails = true;
    }

    @Watch('reference.nonPhysicalDeliveryInstructions')
    private onChangeNonPhysicalDeliveryInstructions(): void {
        this.nonPhysicalDeliveryInstructionsHtml =
            this.reference.nonPhysicalDeliveryInstructions !== undefined && this.reference.nonPhysicalDeliveryInstructions !== null ? this.reference.nonPhysicalDeliveryInstructions!.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
    }

    private async saveNonPhysicalDetails(): Promise<void> {
        this.savingReferenceNonPhysicalDetails = true;

        if (this.reference.isNonPhysical && (this.reference.nonPhysicalDeliveryInstructions === null || this.reference.nonPhysicalDeliveryInstructions === '')) {
            this.savingReferenceNonPhysicalDetails = false;
            return;
        }

        if (!this.reference.isNonPhysical) {
            this.reference.nonPhysicalDeliveryInstructions = undefined;
        }

        try {
            if (
                (this.reference.isNonPhysical === this.referenceCopy.isNonPhysical && this.reference.nonPhysicalDeliveryInstructions === this.referenceCopy.nonPhysicalDeliveryInstructions) ||
                (await referencesService.updateReferenceNonPhysicalDetails(this.reference.id, this.reference.isNonPhysical, this.reference.nonPhysicalDeliveryInstructions))
            ) {
                this.referenceCopy = this.reference.clone();
                this.showEditNonPhysicalDetails = false;

                notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.updateNonPhysicalDetailsSuccess');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.IsNonPhysical,
                        entityId: this.reference.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingReferenceNonPhysicalDetails = false;
        }
    }

    private closeEditNonPhysicalDetails(): void {
        this.reference = this.referenceCopy.clone();
        this.showEditNonPhysicalDetails = false;
    }

    // #endregion NON PHYSICAL DETAILS

    // #region EDIT CATEGORY & CHARACTERISTICS

    private async editCategoryCharacteristics(): Promise<void> {
        this.loadingReferenceCategoryCharacteristics = true;
        await this.editCategoryCharacteristicsGetCategories();
        await this.editCategoryCharacteristicsGetCharacteristics();
        this.showEditCategoryCharacteristics = true;
        setTimeout(() => (this.loadingReferenceCategoryCharacteristics = false), 100);
    }

    private async saveCategoryCharacteristics(): Promise<void> {
        this.savingReferenceCategoryCharacteristics = true;

        this.reference.characteristics = [];
        this.businessCharacteristics.forEach(characteristicAvailable => {
            characteristicAvailable.values.forEach(value => {
                if (value.selected) {
                    const characteristicValue = new CharacteristicValue({ id: value.id, name: value.name });

                    let characteristic = this.reference.characteristics.find(bc => bc.id === characteristicAvailable.id);
                    if (characteristic) {
                        characteristic.values.push(characteristicValue);
                    } else {
                        characteristic = new Characteristic({ id: characteristicAvailable.id, name: characteristicAvailable.name });
                        characteristic.values.push(characteristicValue);
                        this.reference.characteristics.push(characteristic);
                    }
                }
            });
        });

        try {
            if (await referencesService.updateReferenceCategoryCharacteristics(this.reference.id, this.reference.characteristics, this.reference.category.id > 0 ? this.reference.category.id : undefined)) {
                this.referenceCopy = this.reference.clone();
                this.showEditCategoryCharacteristics = false;

                notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.updateCategorizationSuccess');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.CategoriesAndCharacteristics,
                        entityId: this.reference.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingReferenceCategoryCharacteristics = false;
        }
    }

    private async closeEditCategoryCharacteristics(): Promise<void> {
        this.reference = this.referenceCopy.clone();
        this.showEditCategoryCharacteristics = false;
    }

    private async editCategoryCharacteristicsGetCategories(): Promise<void> {
        const topLevelCategories = await referencesClassificationService.getTopLevelCategories(this.reference.businessId!);
        if (this.reference.category.id! > 0) {
            this.initialSelectedCategories = await referencesClassificationService.getCategoriesTreeByCategoryId(this.reference.businessId!, this.reference.category.id);
            topLevelCategories.forEach(c => {
                if (this.initialSelectedCategories.some(sc => sc.id === c.id)) {
                    c.selected = true;
                }
            });
        }

        const categoriesHash: any = {};
        for (const category of topLevelCategories) {
            if (categoriesHash[category.parentCategoryId!] === undefined) {
                categoriesHash[category.parentCategoryId!] = [];
            }
            categoriesHash[category.parentCategoryId!].push(category);
        }
        this.topLevelCategories = this.hierarchySortCategories(topLevelCategories, categoriesHash, null, []);
        this.topLevelCategories = [
            new Category({ id: -1, businessId: this.reference.businessId, name: this.$t('common.ellipsis').toString(), level: 1, selected: this.reference.category ? false : true }),
            new Category({ id: 0, businessId: this.reference.businessId, level: 1, disabled: true, optgroup: true })
        ].concat(this.topLevelCategories);
    }

    private hierarchySortCategories(allCategories: Category[], categoriesHash: any, key: number | null, result: Category[]): Category[] {
        if (categoriesHash[key!] === undefined) {
            return [];
        }

        const categories: Category[] = categoriesHash[key!].sort((left: Category, right: Category) => {
            return left.text!.localeCompare(right.text!, this.$i18n.locale, { sensitivity: 'base' });
        });

        for (const category of categories) {
            if (category.parentCategoryId) {
                const parentCategory = allCategories.find(cat => cat.id === category.parentCategoryId);
                category.level = categoriesHash[parentCategory!.parentCategoryId!][0].level + 1;
            } else {
                category.level = 1;
            }
            result.push(category);
            this.hierarchySortCategories(allCategories, categoriesHash, category.id!, result);
        }

        return result;
    }

    private async editCategoryCharacteristicsGetCharacteristics(): Promise<void> {
        const businessCharacteristics: Characteristic[] = await referencesClassificationService.getCharacteristics(this.reference.businessId!);

        if (businessCharacteristics && businessCharacteristics.length > 0) {
            if (this.reference.characteristics && this.reference.characteristics.length > 0) {
                businessCharacteristics.forEach(businessCharacteristic => {
                    if (this.reference.characteristics.some(c => c.id === businessCharacteristic.id)) {
                        const characteristicReference = this.reference.characteristics.find(c => c.id === businessCharacteristic.id);
                        if (characteristicReference) {
                            businessCharacteristic.values.forEach(businessCharacteristicValue => {
                                if (characteristicReference.values.some(v => v.id === businessCharacteristicValue.id)) {
                                    businessCharacteristic.values.find(v => v.id === businessCharacteristicValue.id)!.selected = true;
                                }
                            });
                        }
                    }
                });
            }
            this.businessCharacteristics = businessCharacteristics;
        } else {
            this.businessCharacteristics = [];
            this.reference.characteristics = [];
        }
    }

    private async editCategoryCharacteristicsOnChangeCategory(selectedCategory: Category, loadingData: boolean): Promise<void> {
        if (selectedCategory && selectedCategory.id! > 0) {
            if (!loadingData) {
                this.reference.category = selectedCategory!.clone();
                this.reference.skus.forEach(sku => (sku.attributes = []));
                this.initialSelectedCategories = [];
            }
        } else {
            this.reference.category = new Category();
            this.initialSelectedCategories = [];
        }
    }

    // #endregion EDIT CATEGORY & CHARACTERISTICS

    // #region SKUs SUMMARY

    private generateSkus() {
        this.$router.push(`/products/${this.reference.id}/generate-skus/${this.reference.category.id}?referenceTitle=${this.reference.title}`);
    }

    private editSkus() {
        this.$router.push(`/products/${this.reference.id}/edit-skus?referenceTitle=${this.reference.title}`);
    }

    // #endregion
}
